import { customerGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import * as z from "zod";

export const getCustomerGroups = {
  name: "getCustomerGroups" as const,
  input: z.object({}),
  output: z.array(customerGroupSchema),
};
